import React, { useState, useEffect } from 'react';
import config from "../config";  // adjust the path as needed


const SMSBalanceCard = () => {
  const [smsBalance, setSmsBalance] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('You are not logged in.');
        setLoading(false);
        return;
      }

      try {
        // Fetch SMS Balance
        // const smsResponse = await fetch('http://127.0.0.1:8000/api/sms-balance/', {
        // const smsResponse = await fetch('https://dseapi.sadhanlab.com/api/sms-balance/', {
        const smsResponse = await fetch(`${config.API_BASE_URL}api/sms-balance/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          },
        });

        // Fetch User Subscriptions
        // const subResponse = await fetch('http://127.0.0.1:8000/api/user-subscription/', {
        // const subResponse = await fetch('https://dseapi.sadhanlab.com/api/user-subscription/', {
        const subResponse = await fetch(`${config.API_BASE_URL}api/user-subscription/`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          },
        });

        if (!smsResponse.ok && !subResponse.ok) {
          throw new Error('Failed to fetch data.');
        }

        if (smsResponse.ok) {
          const smsData = await smsResponse.json();
          setSmsBalance(smsData);
        }

        if (subResponse.ok) {
          const subData = await subResponse.json();
          setSubscriptions(Array.isArray(subData) ? subData : [subData]);
        }

      } catch (err) {
        console.error(err);
        setError('Error fetching data.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>;
  if (error) return <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>;

  return (
    <div style={{
      maxWidth: '900px',
      margin: '40px auto',
      padding: '25px',
      borderRadius: '20px',
      background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Arial, sans-serif',
    }}>
      {/* Title */}
      <h2 style={{
        textAlign: 'center',
        color: '#333',
        marginBottom: '25px',
        borderBottom: '2px solid #007bff',
        paddingBottom: '10px'
      }}>
        Account Overview
      </h2>

      {/* Flex container for horizontal layout */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        justifyContent: 'space-between'
      }}>
        {/* SMS Balance Section */}
        <div style={{
          flex: '1 1 300px',
          padding: '20px',
          borderRadius: '12px',
          backgroundColor: '#e3f2fd',
          boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.05)',
          minWidth: '250px'
        }}>
          <h3 style={{ color: '#0d47a1', marginBottom: '15px', textAlign: 'center' }}>📩 SMS Balance</h3>
          {smsBalance ? (
            <>
              <div style={{ marginBottom: '10px' }}>
                <strong>Free SMS:</strong> {smsBalance.free_sms_balance} <br />
                <strong>Valid Until:</strong> {smsBalance.free_sms_validity || 'N/A'}
              </div>
              <div>
                <strong>Purchased SMS:</strong> {smsBalance.purchased_sms_balance} <br />
                <strong>Valid Until:</strong> {smsBalance.purchased_sms_validity || 'N/A'}
              </div>
            </>
          ) : (
            <p>No SMS balance data found.</p>
          )}
        </div>

        {/* Subscription Section */}
        <div style={{
          flex: '1 1 300px',
          padding: '20px',
          borderRadius: '12px',
          backgroundColor: '#f1f8e9',
          boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.05)',
          minWidth: '250px'
        }}>
          <h3 style={{ color: '#33691e', marginBottom: '15px', textAlign: 'center' }}>💼 User Subscriptions</h3>

          {subscriptions.length > 0 ? (
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              {subscriptions.map((sub, index) => (
                <li key={index} style={{
                  marginBottom: '15px',
                  padding: '10px 15px',
                  borderRadius: '10px',
                  backgroundColor: '#ffffff',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                  transition: 'transform 0.2s',
                  cursor: 'pointer'
                }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  <strong>Member Type:</strong> {sub.member_type} <br />
                  <strong>Expiry Date:</strong> {sub.expiry_date || 'N/A'}
                </li>
              ))}
            </ul>
          ) : (
            <p>No active subscriptions found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SMSBalanceCard;